import React from 'react';
import { Clock, Package, Truck, CheckCircle, AlertCircle } from 'lucide-react';
import { Badge } from '../ui/badge';

const STATUS_CONFIG = {
  pending: { color: 'bg-yellow-500', icon: Clock, text: 'Pending' },
  processing: { color: 'bg-blue-500', icon: Package, text: 'Processing' },
  shipped: { color: 'bg-purple-500', icon: Truck, text: 'Shipped' },
  delivered: { color: 'bg-green-500', icon: CheckCircle, text: 'Delivered' },
  cancelled: { color: 'bg-red-500', icon: AlertCircle, text: 'Cancelled' },
};

export const OrderStatusBadge = ({ status }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.pending;
  const Icon = config.icon;
  return (
    <Badge className={`${config.color} text-white flex items-center gap-1`}>
      <Icon className="w-3 h-3" />
      {config.text}
    </Badge>
  );
};
